var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("div", { staticClass: "page-footer" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c4d8baa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../app/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c4d8baa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../app/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = null
// module chunks = 